import { Loader2, MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useBreakpoint } from '@/hooks/useMediaQuery';

interface WelcomeStateLoaderProps {
  message?: string;
  className?: string;
}

export function WelcomeStateLoader({ 
  message = "Starting your conversation...",
  className 
}: WelcomeStateLoaderProps) {
  const { isMobile } = useBreakpoint();

  return (
    <div className={cn(
      "fixed inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center z-50",
      className
    )}>
      <div className={cn(
        "flex flex-col items-center gap-4 p-6 rounded-lg bg-card border shadow-lg max-w-sm mx-4",
        isMobile ? "p-4" : "p-6"
      )}>
        {/* Animated icon */}
        <div className="relative">
          <div className={cn(
            "rounded-full bg-primary/10 flex items-center justify-center",
            isMobile ? "w-16 h-16" : "w-20 h-20"
          )}>
            <MessageSquare className={cn(
              "text-primary",
              isMobile ? "h-8 w-8" : "h-10 w-10"
            )} />
          </div>
          
          {/* Spinning loader overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader2 className={cn(
              "animate-spin text-primary",
              isMobile ? "h-6 w-6" : "h-8 w-8"
            )} />
          </div>
        </div>
        
        {/* Loading text */}
        <div className="text-center">
          <p className={cn(
            "font-medium text-foreground",
            isMobile ? "text-sm" : "text-base"
          )}>
            {message}
          </p>
          <p className={cn(
            "text-muted-foreground mt-1",
            isMobile ? "text-xs" : "text-sm"
          )}>
            This will only take a moment...
          </p>
        </div>
        
        {/* Progress indicator */}
        <div className="w-full bg-muted rounded-full h-1">
          <div className="bg-primary h-1 rounded-full animate-pulse" style={{
            width: '60%',
            animation: 'pulse 1.5s ease-in-out infinite'
          }} />
        </div>
      </div>
    </div>
  );
}